<template>
  <div>
    <h3>Muutama kysymys kaukolämmittäjälle:</h3>
    <form @submit="onSubmit">
      <div class="form-group">
        <radio-group  v-model="form.district.change.value"
                      groupName="jst_change"
                      label="Kaukolämmittäjän on helppo olla. Oletko kuitenkin sitä mieltä että haluaisit luopua siitä?"
                      :options="form.district.change.options" required/>
      </div>
      <button type="submit" variant="primary">Jatka</button>
      <button type="button" @click="goBack">Takaisin</button>
    </form>
  </div>
</template>
<script>
export default {
  props: [
    'formData',
  ],
  data() {
    const fields = {
      district: {
        change: {
          value: '3',
          options: [
            { text: 'En', value: 0 },
            { text: 'Kyllä', value: 1 },
          ],
        },
      },
    };
    // Merge values
    const form = { ...fields, ...this.formData };
    return {
      form,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.form.answer = this.countAnswers();
      this.$nextTick(() => {
        this.$emit('submitForm', this.form);
      });
    },
    goBack() {
      this.$nextTick(() => {
        this.$emit('goBack', this.form);
      });
    },
    countAnswers() {
      const change = parseInt(this.form.district.change.value, 10);
      let answerPage = 0;
      switch (true) {
        case change === 0:
          answerPage = 8;
          break;
        default:
          answerPage = 9;
          break;
      }
      return answerPage;
    },
  },
};
</script>
<style lang="scss">
  form input::placeholder {
    color: lightgray !important;
  }
  #jst_oil_age {
    display: inline-block;
    max-width: 10rem;
    margin-right: 1rem;
  }
</style>
